$(function() {
    'use strict';

    Odigeo.defineWidget('usersmanager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            dataURL: null,
            action: null,
            timeout: null,
            method: null,
            userDTO: null,
            userUrls: {
                isLoggedIn: {
                    dataURL: 'isloggedin',
                },
            },
            // method overriden from Odigeo
            afterLoadData: Function.prototype,

            getDataRequestSettings: function() {
                var data = this._formatRequestData();
                var type = (this.userUrls[this.action] && !!this.userUrls[this.action].type) ? this.userUrls[this.action].type : 'POST';
                return {
                    type: type,
                    timeout: this.timeout ? this.timeout : 10000,
                    data: 'GET' !== type ? ('string' === typeof data ? data : JSON.stringify(data)) : '',
                    contentType: 'application/json;charset=UTF-8',
                    dataType: 'json',
                    cache: false,
                    success: _.bind(this.requestSuccessHandler, this, this.action),
                    error: _.bind(this.requestErrorHandler, this, this.action),
                };
            },

            _formatRequestData: function() {
                if (!_.isNull(this.action) && !_.isUndefined(this.userUrls[this.action])) {
                    return this.userUrls[this.action].data ? _.extend(this.userUrls[this.action].data, this.get('data')) : this.get('data');
                }
                return null;
            },

            addUserRequest: function(params) {
                this.set({'data': (params && params.data) ? params.data : {}});
                this.set('isMemberAction', params && params.isMemberAction, {silent: true});
                if (params && params.action && !_.isEmpty(this.userUrls[params.action])) {
                    this.dataURL = this.userUrls[params.action].dataURL;
                    if (!_.isEmpty(this.get('data').queryParams)) {
                        this.dataURL += '/?' + _.map(this.get('data').queryParams, function(val, key) {
                            return key + '=' + val;
                        }).join('&');
                    }
                    this.isEmptyData = false;
                    this.action = params.action;
                    this.timeout = this.userUrls[params.action].timeout;
                    this.method = this.userUrls[params.action].method;
                    this.refresh();
                }
            },

            url: function() {
                return Odigeo.Settings.getProperty('serviceUsersFormatter')(this.dataURL);
            },

            requestSuccessHandler: function(action, response) {
                var actionResponse = 'WithError';
                var data = _.isObject(response) && _.isObject(response.attributes) ? response.attributes : response;

                if (true === data || (_.isObject(data) && data.responseOK)) {
                    if (data && !_.isEmpty(data.userDTO)) {
                        this.set('userDTO', data.userDTO);
                    }
                    if ('logOut' === action) {
                        data.membership = this.get('isMemberAction');
                    }
                    actionResponse = 'Ok';
                }
                this.triggerResponse(action + actionResponse, data);
            },

            requestErrorHandler: function(action, xhr) {
                this.triggerResponse(action + 'Error', _.extend(xhr, {action: action}));
            },

            triggerResponse: function(action, data) {
                Odigeo.trigger(this.widget.id + ':' + action, _.extend(true === data ? {} : data, {action: action}));
            },

            clearUser: function() {
                this.clear();
                this.dataURL = null;
                this.isEmptyData = true;
            },
            mixUserAndMember: function(userDTO) {
                var passenger;
                if (require('../modules/helpers/user').isUserDTOMember(userDTO) && !_.isEqual(Odigeo.Utils.getAppInGlobalScope(), 'dp')) {
                    passenger = userDTO.membershipInfoDTO.membershipDTO;
                    userDTO.traveller.push($.extend(true, {}, require('../modules/data/traveller'), {
                        id: 0,
                        typeOfTraveller: 'ADULT',
                        profile: {
                            title: 'MR',
                            name: passenger.name,
                            firstLastName: passenger.lastNames,
                        }}));
                }
            },
        }),

        exposedMethods: {
            'submitUserRequest': 'addUserRequest',
            'clearUser': 'clearUser',
            'mixUserAndMember': 'mixUserAndMember',
        },

        // Exposes a interface to access the widget public methods
        execute: function(func, params) {
            if (this.exposedMethods[func]) {
                this.model[this.exposedMethods[func]](params);
            }
            return this;
        },
    }));
});
